module.exports = __webpack_public_path__ + "static/media/empty-user.21b66d22.png";